import React from 'react'
import {
  BtInput,
  BtNumberInput,
  BtSearchDropdown,
} from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import { statesHashMap } from '@linqpal/models/src/dictionaries'

interface Props {
  value: string
  onChangeText: (arg: string) => void
  label?: string
  style?: any
}

export const State: React.FC<Props> = ({ value, onChangeText, label }) => {
  const { t } = useTranslation('global')
  return (
    <BtSearchDropdown
      options={Object.keys(statesHashMap)}
      mandatory
      onSelect={onChangeText}
      value={value}
      label={label || t('ProjectForm.state')}
      containerStyle={{ marginTop: 20 }}
    />
  )
}

export const City: React.FC<Props> = ({
  value,
  onChangeText,
  label,
  style,
}) => {
  const { t } = useTranslation('global')
  return (
    <BtInput
      value={value}
      onChangeText={onChangeText}
      style={style}
      label={label || t('ProjectForm.city')}
      testID="city"
      mandatory
    />
  )
}

export const Zip: React.FC<Props> = ({ value, onChangeText, label, style }) => {
  const { t } = useTranslation('global')
  return (
    <BtNumberInput
      size="large"
      value={value}
      onChangeText={onChangeText}
      style={style}
      label={label || t('ProjectForm.zip')}
      testID="zip"
      validate={() => (value?.length === 5 ? '' : t('ProjectForm.invalid-zip'))}
      format={'#####'}
      required
    />
  )
}
